import styled from "styled-components";
import { Link as LinkR } from "react-router-dom";
import { theme } from "../../theme/theme";

export const Nav = styled.nav`
  background: ${({ scrollNav }: { scrollNav: boolean }) =>
    scrollNav ? theme.pallete.surface.background : "transparent"};
  height: 80px;
  margin-top: -80px;
  display: flex;
  justify-content: center;
  font-size: 1rem;
  position: sticky;
  top: 0;
  z-index: 10;

  @media screen and (max-width: 960px) {
    transition: 0.8s all ease;
  }
`;

export const NavbarContainer = styled.div`
  display: flex;
  justify-content: space-between;
  height: 80px;
  z-index: 1;
  width: 100%;
  padding: 0 24px;
  max-width: 1300px;
`;

export const NavbarButtons = styled.div`
  display: flex;
  grid-auto-flow: column;
  justify-content: flex-end;
  grid-gap: 16px;
`;

export const NavLogo = styled(LinkR)`
  color: ${theme.pallete.surface.white};
  justify-self: flex-start;
  cursor: pointer;
  font-size: 1.5rem;
  letter-spacing: 0.4px;
  display: flex;
  align-items: center;
  margin-left: 24px;
  margin-right: 100px;

  font-weight: bold;
  text-decoration: none;
`;

export const MobileIcon = styled.div`
  display: none;

  @media screen and (max-width: 1000px) {
    display: block;
    position: absolute;
    top: 0;
    right: 0;
    transform: translate(-100%, 60%);
    font-size: 1.8rem;
    cursor: pointer;
    color: ${theme.pallete.surface.white};
  }
`;

export const NavMenu = styled.ul`
  display: flex;
  align-items: center;
  list-style: none;
  text-align: center;
  margin-right: -22px;
  padding: 0 5rem;

  @media screen and (max-width: 1000px) {
    display: none;
  }
`;

export const NavItem = styled.li`
  height: 80px;
`;

export const NavBtn = styled.nav`
  display: flex;
  align-items: center;

  @media screen and (max-width: 1000px) {
    display: none;
  }
`;

export const NavBtnLink = styled(LinkR)`
  border-radius: 50px;
  background: ${theme.pallete.primary.main};
  white-space: nowrap;
  padding: 10px 22px;
  color: ${theme.pallete.surface.white};
  font-weight: 500;
  letter-spacing: 0.4px;
  font-size: 1rem;
  outline: none;
  border: none;
  cursor: pointer;
  transition: all 0.2s ease-in-out;
  text-decoration: none;

  & :hover {
    transition: all 0.2 ease-in-out;
    background: #270042;
    color: ${theme.pallete.surface.white};
  }
`;
